/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useMemo, useState } from 'react'
import { SeasonDto } from '../../models/dto/Season'
import { SeasonService } from '../..'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { RootState } from 'setup'
import * as core from 'app/modules/core/redux/CoreReducer'

const UseSeason = () => {
    const dispatch = useDispatch()
    //const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
    const [season, setSeason] = useState<SeasonDto>()
    useEffect(() => {
        const getData = async () => {
           
            const result = await SeasonService.GetLastSeason()
            if (result) {
                setSeason(result.data.result)
                dispatch(core.actions.setLastSeason(result.data.result))
            }
        }
        getData()
    }, [])
    return season
}

export default UseSeason
